import { ComponentProps } from 'react'

interface Props extends ComponentProps<'svg'> {
  color?: string
}

export const IconUploadDrag = ({ color = 'currentColor', ...props }: Props) => (
  <svg width="33" height="32" viewBox="0 0 33 32" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={color}
      d="M17.6 7.48125C17.3125 7.175 16.9188 7 16.5 7C16.0813 7 15.6312 7.175 15.4 7.48125L8.9 14.4812C8.3375 15.0887 8.37262 16.0381 8.97812 16.6025C9.58556 17.165 10.5331 17.1318 11.0994 16.5244L15 12.3188V23C15 23.8281 15.6719 24.5 16.5 24.5C17.3281 24.5 18 23.8281 18 23V12.3188L21.9006 16.5194C22.467 17.1268 23.4144 17.16 24.0219 16.5975C24.6274 16.0331 24.6625 15.0837 24.1 14.4762L17.6 7.48125ZM16.5 0C7.6625 0 0.5 7.1625 0.5 16C0.5 24.8375 7.6625 32 16.5 32C25.3375 32 32.5 24.8375 32.5 16C32.5 7.1625 25.3375 0 16.5 0ZM16.5 29C9.33125 29 3.5 23.1681 3.5 16C3.5 8.83187 9.33125 3 16.5 3C23.6688 3 29.5 8.83187 29.5 16C29.5 23.1681 23.6688 29 16.5 29Z"
    />
  </svg>
)
